import { useState, useEffect } from 'preact/hooks';
import useApp from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import useEvent from '../hooks/useEvent';
import { exitTypeArray } from '../consts';
import FormEvent from '../components/ui/FormEvent';


export default function FormEventExit(_route) {
    const [message, setMessage] = useState("");
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const { animals, events, config } = useApp();
    const addToast = useToaster();
    const { getEventInfo, saveEvent } = useEvent();
    const [eventInfo, setEventInfo] = useState(getEventInfo(_route, animals, events));
    eventInfo.event?.exit_type && (eventInfo.exit_type = eventInfo.event.exit_type);
    const msgList = [];
    const selectedAnimals = eventInfo.selectedAnimals;
    eventInfo.isCreateEvent = typeof _route.id == "undefined" || _route.id == "";
    eventInfo.isUnique = _route.animal_id;

    selectedAnimals.map((animal) => {
        if (animal.followed && animal.followed > 0) {
            msgList.push(animal.name + ' est suitée');
        }
    });
    if (msgList.length > 0) setMessage('Attention ! ' + msgList.join(', '));

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const formAnimal = {
            location: config['virtualGraveyardId'] ? "/api/locations/" + config['virtualGraveyardId'] : null,
            exited: true,
        }
        const formEventExit = {
            date: fields.date.value,
            notes: fields.notes.value,
            type: 6,
            exitType: parseInt(fields.exit_type.value),
        }
        let error = 0;
        setSubmitButtonDisabled(true);
        saveEvent(selectedAnimals, formEventExit, formAnimal, _route, true).then((responses) => {
            responses.map(response => {
                addToast(response.type, response.message);
                if (response.type != 'success') error++;
            })
            setSubmitButtonDisabled(false)
        });
        // If it's a new event then add move to the graveyard event
        if (!_route || !_route.id) {
            const formEventMoveToGraveyard = {
                date: fields.date.value,
                location: config['virtualGraveyardId'] ? "/api/locations/" + config['virtualGraveyardId'] : null,
                notes: 'auto',
                type: 1,
            }
            saveEvent(selectedAnimals, formEventMoveToGraveyard, null, _route, true).then((responses) => {
                responses.map(response => {
                    addToast(response.type, response.message);
                    if (response.type != 'success') error++;
                })
            });
        }
        if (error == 0) {
            history.go(-1);
        }
    }

    return (
        <FormEvent title="Sortie"
            onSubmit={handleSubmit}
            eventInfo={eventInfo}
            message={message}
            submitButtonDisabled={submitButtonDisabled}
            setEventInfo={setEventInfo}>
            <div class="form-floating mb-3">
                <select class="form-select" id="exit_type" name="exit_type" value={eventInfo.exit_type}>
                    <option value="">- Choisissez -</option>
                    {
                        exitTypeArray.map((type, id) => {
                            return (
                                <option key={id} value={id}>{type}</option>
                            )
                        })
                    }
                </select>
                <label class="form-label" for="location">Type de sortie</label>
            </div>
        </FormEvent>
    );
}